module.exports = __webpack_public_path__ + "public/SiteImages/noPaymentImage.svg?cc6aafd6";